import SectorService from '../../services/Sector.js';
import Multiselect from 'vue-multiselect';
import InfiniteLoading from 'vue-infinite-loading';

if($('#networks-list-component').length){
    var app = new Vue({
        el: '#networks-list-component',
        data: {
            loading:true,
            firstLoad:true,
            sectors:[],
            sectorSlugs:[],
            networks:[],
            filters:[
                {
                    'name':'Active',
                    'slug':'current'
                },
                {
                    'name':'Closed',
                    'slug':'expired'
                }
            ],
            filterSlugs:['current','expired'],
            searchOptions:{
                sector:sector,
                filter:'current',
                search:'',
                sort: {name: 'Newest-Oldest', value: 'newest_first'}
            },
            type:type,
            page:1,
            sortOptions: [
                {name: 'A-Z', value: 'a_z'},
                {name: 'Z-A', value: 'z_a'},
                {name: 'Newest-Oldest', value: 'newest_first'},
                {name: 'Oldest-Newest', value: 'oldest_first'},
                {name: 'Closest-Furthest Away End Date', value: 'end_date_furthest_away'},
                {name: 'Furthest Away-Closest End Date', value: 'end_date_closest'}
            ],
            api_url: api_url
        },
        methods: {
            getNetworks($state){
                let url = this.constructUrl();
                url = url + '&page='+this.page;

                var scrollPosition = null;
                if(this.firstLoad && sessionStorage.scrollPos && sessionStorage.scrollPos != 0){
                    url = url + '&loadAll=true'
                    scrollPosition = sessionStorage.scrollPos;
                }

                axios.get(this.api_url + '/api/v1'+url).then((response) =>  {
                    if(this.page == 1 && response.data){
                        this.networks = response.data.networks.data;
                        // this.networks.splice(2, 0, null);
                    }else{
                        this.networks.push.apply(this.networks, response.data.networks.data)
                    }

                    this.loading = false;
                    this.page ++;
                    if(this.page > response.data.networks.last_page){
                        $state.complete();
                    }else{
                        $state.loaded();
                    }

                    if(this.firstLoad){
                        this.$nextTick(() => {
                            if(scrollPosition){
                                $(window).scrollTop(scrollPosition)
                            }
                        });
                    }

                    this.firstLoad = false;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getParameter(name, url = window.location.href){
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            getSectorName(option){
                let value = this.sectors.filter(obj => {
                    return obj.slug === option
                });
                return value[0].name;
            },
            getFilterName(option){
                let value = this.filters.filter(obj => {
                    return obj.slug === option
                });
                return value[0].name;
            },
            debounceInput: _.debounce(function () {
                this.processSearch();
            }, 1000),
            constructUrl(){

                let url = '/networks/'+this.type;

                if (sessionStorage.getItem("sector")) {
                    url = url + '/' + sessionStorage.getItem("sector");
                } else if (this.searchOptions.sector) {
                    url = url + '/' + this.searchOptions.sector;
                }

                if(this.searchOptions.search){
                    url = url+'?search='+this.searchOptions.search;
                }else{
                    url = url+'?search=';
                }

                if (sessionStorage.getItem("filter")) {
                    url = url + '&filter=' + sessionStorage.getItem("filter");
                } else if (this.searchOptions.filter) {
                    url = url + '&filter=' + this.searchOptions.filter;
                }

                if (sessionStorage.getItem("sort_name") && sessionStorage.getItem("sort_value")) {
                    url = url + '&sort=' + sessionStorage.getItem("sort_value");
                } else if (this.searchOptions.sort) {
                    url = url + '&sort=' + this.searchOptions.sort.value;
                }

                return url;
            },
            processSearch(){
                if (this.searchOptions.filter) {
                    sessionStorage.setItem("filter", this.searchOptions.filter);
                }
                if (this.searchOptions.sort) {
                    sessionStorage.setItem("sort_name", this.searchOptions.sort.name);
                    sessionStorage.setItem("sort_value", this.searchOptions.sort.value)
                }
                if (this.searchOptions.sector) {
                    sessionStorage.setItem("sector", this.searchOptions.sector);
                }
                this.networks = [];
                this.page = 1;
                this.firstLoad = true;
                this.loading = true;
                this.$refs.infiniteLoading.stateChanger.reset();
            },
            truncate(str, n){
                str.replace(/<\/?[^>]+(>|$)/g, "");
                return (str.length > n) ? str.substr(0, n-1) + '&hellip;' : str;
            },
            removeFilter(removedOption, id) {
                sessionStorage.removeItem("filter");
            },
            removeSort(removedOption, id) {
                sessionStorage.removeItem("sort_name");
                sessionStorage.removeItem("sort_value");
            },
            removeSector(removedOption, id) {
                sessionStorage.removeItem("sector");
            },
            callSectors() {
                if (this.sectorSlugs.length === 0) {
                    SectorService.getSectors().then(data => {
                        this.sectors = data;
                        this.sectorSlugs = this.sectors.map(a => a.slug);
                        if (sessionStorage.getItem("sector")) {
                            this.searchOptions.sector = sessionStorage.getItem("sector");
                        } else {
                            this.searchOptions.sector = sector;
                        }
                    });
                }
            }
        },
        mounted () {

            let performanceTiming = performance.getEntriesByType('navigation')[0];
            if (performanceTiming.type === 'navigate') {
                sessionStorage.removeItem("filter");
                sessionStorage.removeItem("sort_name");
                sessionStorage.removeItem("sort_value");
                sessionStorage.removeItem("sector");
            }

            this.searchOptions.search = this.getParameter('search');

            if (sessionStorage.getItem("filter")) {
                this.searchOptions.filter = sessionStorage.getItem("filter");
            } else if (this.getParameter('filter')){
                this.searchOptions.filter = this.getParameter('filter');
            }

            if (sessionStorage.getItem("sort_name") && sessionStorage.getItem("sort_value")) {
                this.searchOptions.sort.name = sessionStorage.getItem("sort_name");
                this.searchOptions.sort.value = sessionStorage.getItem("sort_value");
            } else if(this.getParameter('sort')){
                this.searchOptions.sort = this.getParameter('sort');
            }

            $(window).scroll(function () {
                sessionStorage.scrollPos = $(window).scrollTop();
            });
        },
        components: {
            'multiselect': Multiselect,
            InfiniteLoading,
        },
    });
}